import { HttpInterceptorFn } from '@angular/common/http';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const isBrowser = typeof window !== 'undefined';

  const token = isBrowser ? localStorage.getItem('accessToken') : null;
  const language = isBrowser ? localStorage.getItem('language') : 'en';

  const excludedUrls = ['/login', '/register'];
  const isExcluded = excludedUrls.some((url) => req.url.includes(url));

  if (isExcluded) return next(req);

  const headers: Record<string, string> = {
    'X-LOCALIZE': language ?? 'en',
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const cloned = req.clone({
    setHeaders: headers,
  });

  return next(cloned);
};
